module.exports = __webpack_public_path__ + "static/media/ice-cream.4201df46.png";